import { totalStaffCount } from '../../../Game/GamePlayerInfo';
import WeightedChoiceBase from './WeightedChoiceBase';

export default class ShouldIChooseStaff extends WeightedChoiceBase {

    constructor(gameController, aiPackage) {
        super(gameController, aiPackage);
        this.total = totalStaffCount(this._gamePlayerData);
    }

    _novice = (recursive=false) => {
        if (!recursive) this._aiPackage.addProvenance(
            'What is my Affinity with Staff?', 'Novice');
        let weight = 0;


        let question = 'Do I have enough Staff?';
        let answer = true;
        let reasoning = `I like to have at least 3 staff, I have ${this.total}.`;
        if (this.total < 3){
            answer = false;
            weight += 3;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);
        this._weight += weight
    }

    _reasonable = (recursive=false) => {
        if (!recursive) this._aiPackage.addProvenance(
            'What is my Affinity with Staff?', 'Reasonable');
        let weight = 0;


        let question = 'Do I have enough Staff?';
        let answer = true;
        let reasoning = `I like to have at least 6 staff, I have ${this.total}.`;
        let missing = 6 - this.total;

        if (missing > 0){
            answer = false;
            weight += missing;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);
        if (this._weight > 4) {
            this._weight = 4
        }
        this._weight += weight;
    }

    _persistent = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Staff', 'Persistent');
        this._reasonable(true);
        if (this._weight < 1) {
            this._weight = 1
        }
    }
    _unreasonable = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Staff', 'Unreasonable');
        this._reasonable(true);
        if (this._weight < 2) {
            this._weight = 2
        }

    }

    _obsessed = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Staff', 'Obsessed');
        this._reasonable(true);
        if (this._weight < 3) {
            this._weight = 3
        }
    }
}
